import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import clone from "lodash.clonedeep";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
    Row, Col, MenuItem, Dropdown, Button, Modal,
    ButtonGroup, Glyphicon, ListGroupItem, ControlLabel, FormGroup
} from "react-bootstrap";
import MoveIcon from "../../../Widgets/components/Icons/MoveIcon";
import { useEventContext } from "../../../../../context";
import { quizGetByEvent } from "../../../../../../api/cp";
import Loading from "../../../../Loading";

const QuizEditModal = ({ quiz, handleSaveQuiz, handleChangeQuiz, streamOptions, quizValues }) => {
    if (!quiz) return null;

    return <>
        <Modal.Header closeButton>
            <Modal.Title>{quizValues?.titleRu || quizValues?.titleEn}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormGroup>
                <ControlLabel>Только для этих залов</ControlLabel>
                <Select
                    isMulti
                    placeholder="Залы не выбраны"
                    value={streamOptions.filter(({ value }) => quiz.showInStreams?.includes(value))}
                    options={streamOptions}
                    onChange={(value) => handleSaveQuiz({ showInStreams: value.map(item => item.value) })}
                />
            </FormGroup>
        </Modal.Body>
    </>
}

export default ({ blockProperties, onSave, onUpdateBlockProperties }) => {
    const { event } = useEventContext();
    const [quizzesOptions, setQuizzesOptions] = useState([]);
    const [editingQuiz, setEditingQuiz] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const quizzes = blockProperties?.quizzes || [];

    const quizzesnFilterOptions = useMemo(() => {
        const excludedIds = quizzes.map(item => item.id);
        return quizzesOptions.filter(({ id }) => !excludedIds.includes(id));
    }, [quizzesOptions, quizzes]);

    const streamOptions = useMemo(() => {
        return event.stream?.map((stream) => ({ value: stream.id, label: stream.description_ru || stream.description_en }));
    }, [event.stream]);

    const getQuizzes = async () => {
        try {
            setIsLoading(true);
            const quizzes = await quizGetByEvent(event.eventKey);
            setQuizzesOptions(quizzes);
        } catch (e) {
            console.error(e);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getQuizzes();
    }, [event]);

    const handleAddQuiz = (quizId) => {
        const newQuiz = {
            id: quizId,
            displaySize: 1,
            showInStreams: blockProperties.showInStreams,
            order: quizzes.reduce((order, cur) => cur.order > order ? cur.order : order, 0) + 1,
        }
        onSave({ quizzes: [...quizzes, newQuiz] });
    }

    const handleDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const _quizzes = clone(quizzes);
        const [removed] = _quizzes.splice(result.source.index, 1);
        _quizzes.splice(result.destination.index, 0, removed);
        const _result = { quizzes: _quizzes.map((button, idx) => ({ ...button, order: idx + 1 })) };
        onUpdateBlockProperties(_result)
        onSave(_result);
    }

    const handleDeleteQuiz = (quizID) => {
        const _quizzes = quizzes.filter(({ id }) => id !== quizID);
        const _result = { quizzes: _quizzes.map((quiz, idx) => ({ ...quiz, order: idx + 1 })) };
        onUpdateBlockProperties(_result);
        onSave(_result);
    }

    const handleSaveQuiz = (properties) => {
        if (!editingQuiz) return;
        const _editingQuiz = { ...editingQuiz, ...properties };
        setEditingQuiz(_editingQuiz)
        const _result = { quizzes: quizzes.map((quze) => quze.id === editingQuiz.id ? _editingQuiz : quze) };
        onUpdateBlockProperties(_result);
        onSave(_result);
    }

    const handleChangeQuiz = (key, value) => {
        setEditingQuiz(quiz => ({ ...quiz, [key]: value }))
    }

    return (
        <div>
            <Row>
                <Col xs={12}>
                    <Dropdown
                        id="add-quiz"
                    >
                        <Dropdown.Toggle>
                            Добавить квиз
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {
                                quizzesnFilterOptions.map((quiz) => (
                                    <MenuItem
                                        key={quiz.id}
                                        onClick={() => handleAddQuiz(quiz.id)}
                                    >
                                        {quiz.titleRu || quiz.titleEn}
                                    </MenuItem>
                                ))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Col xs={12}>
                    {isLoading && <Loading />}
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided) => (
                                <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {!isLoading && quizzes.map((quiz, index) => {
                                        const quizValues = quizzesOptions.find(({id}) => id === Number(quiz.id));

                                        return (
                                            <Draggable
                                                key={quiz.id}
                                                draggableId={`${quiz.id || index}`}
                                                index={index}
                                            >
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            ...provided.draggableProps.style,
                                                            left: 0,
                                                            top: provided.draggableProps.style?.top - 22 || 0
                                                        }}
                                                    >
                                                        <ListGroupItem
                                                            key={quiz.id}
                                                            style={{
                                                                padding: '4px 4px 4px 12px',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                height: '44px',
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', gap: '0.5rem' }}>
                                                                <MoveIcon />
                                                                <span>{quizValues?.titleRu || quizValues?.titleEn}</span>
                                                            </div>
                                                            <ButtonGroup>
                                                                <Button onClick={() => setEditingQuiz(quiz)}>
                                                                    <Glyphicon glyph="edit" />
                                                                </Button>
                                                                <Button bsStyle="danger"><Glyphicon glyph="trash" onClick={() => handleDeleteQuiz(quiz.id)} /></Button>
                                                            </ButtonGroup>
                                                        </ListGroupItem>
                                                    </div>
                                                )}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </Col>
            </Row>
            <Modal
                show={!!editingQuiz}
                onHide={() => setEditingQuiz(null)}
            >
                <QuizEditModal
                    quiz={editingQuiz}
                    handleSaveQuiz={handleSaveQuiz}
                    handleChangeQuiz={handleChangeQuiz}
                    streamOptions={streamOptions}
                    quizValues={editingQuiz && quizzesOptions.find(({id}) => id === editingQuiz.id)}
                />
            </Modal>
        </div>
    )
};
